import { Box, Button, Card, CircularProgress, Divider, Grid, Typography } from "@mui/material"
import React from "react"
import HomeState from "../../../../State/HomeState"
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import PaymentIcon from '@mui/icons-material/Payment';
import ProfileDispatch from "./model";
class Profile extends React.PureComponent<{}>{

    render() {
        let state: HomeState = (this.props as any).state
        let dispatcher: ProfileDispatch = (this.props as any).dispatcher

        let html: JSX.Element

        if (state.loading) {
            html = <Box sx={{ height: '100%', flexDirection: 'column' }} display="flex"
                justifyContent="center"
                alignItems="center">
                <CircularProgress />
                <Typography variant="subtitle1" sx={{ mr: 1, ml: 1 }}>
                    در حال دریافت اطلاعات
                </Typography>
            </Box>
        } else {
            if (state.user) {
                html = <Box sx={{ height: '100%', flexDirection: 'column', mt: 5 }} display="flex"
                    alignItems="center">

                    <Box
                        component="img"
                        sx={{
                            height: '120px',
                            width: '120px',
                            borderRadius: '60px'
                        }}
                        alt='profile pic'
                        src={state.user.pic}
                        crossOrigin="anonymous"
                    />
                    <Divider orientation="horizontal" variant="middle" flexItem sx={{ mt: 3 }} />

                    <Typography fontWeight='fontWeightBold' variant="h6" display="block" gutterBottom sx={{ mr: 1, ml: 1, mt: 3 }}>
                        {state.user.name}
                    </Typography>
                    <Typography variant="subtitle1" display="block" gutterBottom sx={{ mr: 1, ml: 1 }}>
                        {state.user.phone}
                    </Typography>

                    <Typography variant="subtitle1" display="block" gutterBottom sx={{ mr: 1, ml: 1 }}>
                        املاک {state.user.realEstateName}
                    </Typography>
                    <Typography variant="subtitle1" display="block" gutterBottom sx={{ mr: 1, ml: 1 }}>
                        {state.user.activity}
                    </Typography>

                    <Typography variant="subtitle1" display="block" gutterBottom sx={{ mr: 1, ml: 1 }}>
                        عضویت از تاریخ {new Date(state.user.registerDate).toLocaleDateString('fa-IR')}
                    </Typography>

                    <Typography variant="subtitle1" display="block" gutterBottom sx={{ mr: 1, ml: 1 }}>
                        اشتراک تا تاریخ {new Date(state.user.expireDate).toLocaleDateString('fa-IR')}
                    </Typography>
                    <Typography variant="subtitle1" display="block" gutterBottom sx={{ mr: 1, ml: 1 }}>
                        موجودی کیف پول : {state.user.wallet.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} تومان
                    </Typography>

                    <Box sx={{ flexGrow: 1 }} />

                    <Grid container >
                        <Grid item>
                            <Button variant="contained" startIcon={<ShoppingBasketIcon sx={{ ml: 1 }} />} color="secondary" size='small' onClick={() => {
                                dispatcher.orders()
                            }}>
                                سفارشات من
                            </Button>
                        </Grid>
                        <Divider orientation="vertical" variant="middle" flexItem sx={{ ml: 1, mr: 1 }} />
                        <Grid item>
                            <Button variant="contained" startIcon={<PaymentIcon sx={{ ml: 1 }} />} color="warning" size='small' onClick={() => {
                                dispatcher.payments()
                            }}>
                                تاریخچه پرداخت
                            </Button>
                        </Grid>
                    </Grid>

                </Box>
            } else {
                //....
                html = <div></div>
            }

        }

        return (
            <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ flexDirection: 'row' }} display="flex"
                    justifyContent="center"
                    alignItems="center">
                    <Typography fontWeight='fontWeightBold' variant="h6" display="block" gutterBottom sx={{ mr: 1, ml: 1 }} color='primary'>
                        پروفایل کاربری
                    </Typography>
                </Box>

                <Divider orientation="horizontal" variant="middle" flexItem sx={{ mt: 1 }} />
                <Box sx={{ height: '100%', width: '100%', flexDirection: 'column', mt: 2 }} display="contents"
                    justifyContent="center"
                    alignItems="center">
                    <Card variant="elevation" sx={{ height: '100%', borderRadius: '12px', borderColor: 'transparent', p: 2, mr: 1, ml: 1, mt: 1 }} >
                        <Box sx={{ flexDirection: 'column', height: '100%' }} display="flex">

                            {html}
                        </Box>
                    </Card>
                </Box>
            </Box>
        )
    }
}

export default Profile